<template>
  <portlet :variant="bgColor">
    <form autocomplete="no">
      <form-row>
        <div class="col">
          <h3 class="form_section_title">
            個人資料
          </h3>
        </div>
      </form-row>
      <form-row>
        <form-group class="col-md-4 col-sm-12" label="學號">
          <input-group>
            <form-input v-model="student.student_id" name="student_id" placeholder="M123456789"
              :readonly="lockStudentId" />
          </input-group>
        </form-group>
        <form-group class="col-md-4 col-sm-12" label="E-mail">
          <input-group>
            <form-input :value="`${student.student_id}@mail.ntust.edu.tw`" name="student_email" readonly />
          </input-group>
        </form-group>

        <form-group class="col-md-4 col-sm-12" label="性別">
          <input-group>
            <form-select :default-value="student.student_sex" :options="[{
                name: '男',
                value: 1,
              }, {
                name: '女',
                value: 0,
              }]" name="sex" @change="sexSelected"/>
          </input-group>
        </form-group>

      </form-row>
      <form-row>
        <form-group class="col-md-4 col-sm-12" label="備用信箱">
          <input-group>
            <form-input v-model="student.student_alt_email" name="student_alt_email" />
          </input-group>
        </form-group>
        <form-group class="col-md-4 col-sm-12" label="姓名">
          <input-group>
            <form-input v-model="student.student_name" name="student_name" />
          </input-group>
        </form-group>
        <form-group class="col-md-4 col-sm-12" label="聯絡電話">
          <input-group>
            <form-input v-model="student.student_phone_number" name="student_phone" />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group class="col-md-4 col-sm-12">
          <input-group>
            <template slot="prepend">
              <span class="input-group-text text-muted">
                學制
              </span>
            </template>
            <form-select :default-value="initialDegree" :options="[{
              name: '四技',
              value: 'four-year technical program',
            }, {
              name: '研究所',
              value: 'graduate student',
            }, {
              name: '博士班',
              value: 'doctoral student'
            }, {
              name: '學士後',
              value: 'post-baccalaureate student'
            }, {
              name: '二技',
              value: 'two-year technical program'
            }, {
              name: '台巴科大交換生',
              value: 'UPTP exchange student'
            }]" name="academic_degree" disabled @change="degreeSelected" />
          </input-group>
        </form-group>
        <form-group class="col-md-4 col-sm-12">
          <input-group>
            <template slot="prepend">
              <span class="input-group-text text-muted">
                系所
              </span>
            </template>
            <form-select :default-value="student.student_department" :options="departmentOptions"
              :placeholder="departmentsGetter.length ? '請選擇...' : '請先選擇學制...'" name="departments"
              select-name="department_name" select-value="department_id" @change="departmentSelected" />
          </input-group>
        </form-group>
        <form-group class="col-md-4 col-sm-12">
          <input-group>
            <template slot="append">
              <span class="input-group-text text-muted">
                年級
              </span>
            </template>
            <form-select :default-value="student.student_grade" :options="degreeGrades"
              :placeholder="departmentsGetter.length ? '請選擇...' : '請先選擇學制...'" name="degree_grade"
              @change="gradeSelected" />
          </input-group>
        </form-group>
      </form-row>
      <form-section-divider />
      <form-row>
        <div class="col">
          <h3 class="form_section_title">
            密碼設定<span class="ps_text">* 密碼最少為6碼</span>
          </h3>
        </div>
      </form-row>
      <form-row>
        <form-group class="col-md-6 col-sm-12" label="密碼">
          <input-group>
            <form-input v-model="student.password" type="password" name="student_password" autocomplete="no" />
          </input-group>
        </form-group>
        <form-group class="col-md-6 col-sm-12" label="密碼確認">
          <input-group>
            <form-input v-model="student.password_confirmation" type="password" name="student_password_confirmation" />
          </input-group>
        </form-group>
      </form-row>
      <form-section-divider v-show="false" />
      <!-- <form-row v-show="!showPrivacyPolicy" >
        <div class="col">
          <h3 class="form_section_title" style="font-family: 'Raleway', sans-serif;">
            LINE設定
          </h3>
        </div>
      </form-row> -->
      <!-- <form-row v-show="!showPrivacyPolicy" >
        <form-group class="col-md-6 col-sm-12" label="LINE UID">
          <input-group>
            <form-input v-model="selectedstudentlineUID" type="text" autocomplete="no" />
          </input-group>
        </form-group>
        <form-group class="col-md-6 col-sm-12" label="加入LINE">
          <img src="https://qr-official.line.me/sid/M/590nvabu.png?shortenUrl=true" width="50%">
        </form-group>
      </form-row>
      <form-row v-show="false" >
        <form-group class="col-md-4 col-sm-12" label="通知活動類別">
          <div v-for="item in clineCategory">
            <label>{{ item.category }}</label>
            <input type="checkbox" :value="item.id" v-model="selectedLineCategory">
          </div>
        </form-group>
        <form-group class="col-md-4 col-sm-12" label="通知消息類別">
          <div v-for="item in clineNews">
            <label>{{ item.news }}</label>
            <input type="checkbox" :value="item.value" v-model="selectedLineNews">
          </div>
        </form-group>
        <form-group class="col-md-4 col-sm-12" label="通知設置">
          <div v-for=" item in clineSetting">
            <label>{{ item.settings }}</label>
              <form-select :default-value="selectedLineSetting" :options="timeOptions" :placeholder="'請選擇...'"
                name="notify_time" @change="timeSelected" />
          </div>
        </form-group>
      </form-row> -->
      <form-section-divider v-show="showPrivacyPolicy" />
      <form-row>
        <div class="col">
          <div v-if="showPrivacyPolicy" class="form-check">
            <check-input label="同意" name="agree-privacy-policy" @change="isAgreePrivacyPolicy">
              <template slot="label">
                <button-wrapper thickness="xs" @click.prevent="openPolicyWindow">
                  隱私權政策的適用範圍及個人資料安全之保護聲明」
                </button-wrapper>
              </template>
            </check-input>
          </div>
        </div>
        <div class="col-md-2 col-sm-4 align-self-end">
          <button-wrapper size="fill" :disabled="cantSubmit" class="float-right" @click.prevent="submitData">
            確定
          </button-wrapper>
        </div>
      </form-row>
    </form>
  </portlet>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Portlet from '~components/common/Portlet'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import InputGroup from '~components/common/form/input/Group'
import ButtonWrapper from '~components/common/buttons'
import FormSelect from '~components/common/form/Select'
import FormSectionDivider from '~components/common/form/section/Divider'
import CheckInput from '~components/common/form/input/Check'
export default {
  name: 'StudentProfileForm',
  components: {
    Portlet,
    FormRow,
    FormGroup,
    FormInput,
    InputGroup,
    ButtonWrapper,
    FormSelect,
    FormSectionDivider,
    CheckInput
  },
  props: {
    account: {
      type: String,
      default: ''
    },
    lockStudentId: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ''
    },
    showPrivacyPolicy: {
      type: Boolean,
      default: false
    },
    currentStudent: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      cantSubmit: this.showPrivacyPolicy,
      student: {
        student_id: '',
        student_sex: '',
      },
      currentDegree: '',
      initialDegree: '',
      degreeLimit: {
        B: 8,
        M: 4,
        D: 7,
        C: 4,
        A: { start: 2, end: 4 },
        F: { start: 2, end: 4 }
      },
      grades: [{
        name: 'ㄧ',
        value: 1
      }, {
        name: '二',
        value: 2
      }, {
        name: '三',
        value: 3
      }, {
        name: '四',
        value: 4
      }],
      studentType: {
        'four-year technical program': 'B',
        'graduate student': 'M',
        'doctoral student': 'D',
        'post-baccalaureate student': 'C',
        'two-year technical program': 'A',
        'UPTP exchange student': 'F'
      },
      clineNews: [{
        value: 1,
        news: '實習資訊'
      },
      {
        value: 2,
        news: '徵才快報'
      }, {
        value: 3,
        news: '活動公告'
      }, {
        value: 4,
        news: '一般訊息'
      }],
      timeOption: [
        {
          name: '不通知',
          value: '1'
        }, 
        {
          name: '一小時前',
          value: '2'
        }, {
          name: '一天前',
          value: '3'
        }, {
          name: '一週前',
          value: '4'
        }
      ],
      selectedLineCategory: [],
      selectedLineSetting: '',
      selectedstudentlineUID: '',
      selectedLineNews: [],
      addcheck: true,
    }
  },
  computed: {
    ...mapActions('pages/students', {
      clineCategorytest: 'getCurrentLineCategory',
      clineSettingtest: 'getCurrentLineSetting'
    }),
    ...mapGetters('pages/students', [
      'departmentsGetter',
      'currentLineCategoryGetter',
      'currentLineSettingGetter'
    ]),
    degreeGrades() {
      if (this.degreeLimit[this.currentDegree] instanceof Object) {
        return this.grades.slice(this.degreeLimit[this.currentDegree].start, this.degreeLimit[this.currentDegree].end)
      } else {
        return this.grades.slice(0, this.degreeLimit[this.currentDegree])
      }
    },
    departmentOptions() {
      return this.departmentsGetter
        .filter(
          dept => dept.department_degree === this.currentDegree
        )
    },
    timeOptions() {
      return this.timeOption.slice(0)
    },
    clineCategory() {
      if (this.clineCategorytest != null) return this.currentLineCategoryGetter

    },
    clineSetting() {
      if (this.clineSettingtest != null) return this.currentLineSettingGetter
    }
  },
  watch: {
    currentStudent(value) {
      this.student = Object.assign({}, value)
      this.setInitialDegree(value.student_academic_degree)
      if (Object.keys(value).length) {
        this.student.student_id = value.student_id
      }

      if (this.addcheck) {
        if (this.student.student_lineCategory != null) this.selectedLineCategory = this.student.student_lineCategory.split(",")
        if (this.student.student_lineNews != null) this.selectedLineNews = this.student.student_lineNews.split(",")
        if (this.student.student_lineSetting != null)this.selectedLineSetting = this.student.student_lineSetting
        if (this.student.student_lineUID != null)this.selectedstudentlineUID = this.student.student_lineUID
        this.addcheck = false
      }

    },
    currentDegree(value) {
      if (value) this.getDepartments(value)
    }
  },
  async created() {
    await this.getDepartments()
    if (this.account) {
      this.student.student_id = this.account
      const degree = this.currentStudentAcademicDegree(this.account)
      if (Object.keys(this.degreeLimit).includes(degree)) {
        this.setInitialDegree(degree)
      }
    }
  },
  methods: {
    ...mapActions('pages/students', [
      'getDepartments',
    ]),
    setInitialDegree(degree) {
      this.currentDegree = degree
      this.initialDegree = Object.keys(this.studentType).find(key => this.studentType[key] === this.currentDegree)
    },
    currentStudentAcademicDegree(value) {
      return value.charAt(0).toUpperCase()
    },
    openPolicyWindow() {
      const target = this.$router.resolve('/privacy-policy')
      window.open(target.href, '_blank')
    },
    degreeSelected(degree) {
      this.currentDegree = this.studentType[degree.value]
    },
    departmentSelected(dept) {
      this.student.student_department = dept.department_id
    },
    gradeSelected(grade) {
      this.student.student_grade = grade.value
    },
    isAgreePrivacyPolicy(isChecked) {
      this.cantSubmit = !isChecked
    },
    timeSelected(e) {
      this.selectedLineSetting = e.value
    },
    sexSelected(e) {
      this.student.sex = e.value
    },
    submitData() {
      this.selectedLineNews.sort(function(a, b){return a-b});
      this.selectedLineCategory.sort(function(a, b){return a-b});
      this.student.student_lineCategory = this.selectedLineCategory.toString()
      this.student.student_lineSetting = this.selectedLineSetting
      this.student.student_lineUID  = this.selectedstudentlineUID  
      this.student.student_lineNews = this.selectedLineNews.toString()
      if (this.student.sex === undefined) {
        this.student.sex = this.student.student_sex;
      }
      this.$emit('submit', this.student)

    }
  }
}
</script>
